import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Icon } from '@ibk/shared-ui';
import styles from './NewBadge.module.css';
export const NewBadge = ({ text, className = '', 'data-testid': dataTestId }) => {
    return (_jsxs("span", { className: `${styles.badge} ${className}`, "data-testid": dataTestId || 'new-badge', children: [_jsx(Icon, { name: 'checkMarkCircle', className: styles.icon }), text] }));
};
